import React, {Component} from 'react';
import { Link } from 'react-router-dom';

class HomeStaticBanner2 extends Component {

    constructor(props) {
        super(props);
        this.state = {
            // menu:[],
        }
    }

    render() {
        const banners = (this.props.banner || []).filter((bannerItem) => bannerItem.image_path && bannerItem.image_path.trim() !== '');
        return (
        <div className="container">
                 <div className="row">
                 {
                    banners.map((bannerItem, index)=>{
                        return( 
                            <div className="col-6 col-md-6 byosBannerMobile" key={`${bannerItem.image_path}-${index}`}>
                                <div className="ps-promo__item ps-static-banner ps-static-banner--half">
                                    <div className="ps-static-banner__imageWrap">
                                        <img className="ps-promo__banner ps-static-banner__image" src={bannerItem.image_path} alt={bannerItem.image_title || 'Banner'} />
                                    </div>
                                </div>
                            </div>
                            )
                        })
                    }
                 </div>
        </div>
        );
    }
}

export default HomeStaticBanner2;
